let currentEnvelopeId = null;

function openShareModal(envelopeId) {
  currentEnvelopeId = envelopeId;
  document.getElementById('share-modal').style.display = 'flex';
  document.getElementById('share-user-search').value = '';
  document.getElementById('share-search-results').style.display = 'none';
  loadSharedUsers();
}

function closeShareModal() {
  document.getElementById('share-modal').style.display = 'none';
  currentEnvelopeId = null;
}

function loadSharedUsers() {
  const container = document.getElementById('share-current-users');
  container.innerHTML = '<div style="font-size:13px;color:#9CA3AF">Loading...</div>';
  fetch(`/envelopes/${currentEnvelopeId}/shared_users`)
    .then(r => r.json())
    .then(users => {
      if (users.length === 0) {
        container.innerHTML = '<div style="font-size:13px;color:#9CA3AF">Not shared with anyone yet.</div>';
        return;
      }
      container.innerHTML = users.map(u => `
        <div style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid #F3F4F6">
          <div>
            <div style="font-size:13px;font-weight:500">${u.name}</div>
            <div style="font-size:11px;color:#9CA3AF">${u.email}</div>
          </div>
          <button data-action="unshare-user" data-user-id="${u.id}"
            style="font-size:11px;color:#EF4444;background:none;border:none;cursor:pointer;padding:2px 6px">Remove</button>
        </div>
      `).join('');
      document.querySelectorAll('[data-action="unshare-user"]').forEach(btn => {
        btn.addEventListener('click', function() {
          unshareUser(this.dataset.userId);
        });
      });
    });
}

function searchUsers(query, allUsers) {
  const results = document.getElementById('share-search-results');
  if (!query.trim()) { results.style.display = 'none'; return; }
  const filtered = allUsers.filter(u =>
    u.name.toLowerCase().includes(query.toLowerCase()) ||
    u.email.toLowerCase().includes(query.toLowerCase())
  );
  if (filtered.length === 0) {
    results.innerHTML = '<div style="padding:10px 12px;font-size:13px;color:#9CA3AF">No users found</div>';
  } else {
    results.innerHTML = filtered.map(u => `
      <div data-action="share-user" data-user-id="${u.id}"
        style="padding:8px 12px;cursor:pointer;font-size:13px;border-bottom:1px solid #F3F4F6">
        <span style="font-weight:500">${u.name}</span>
        <span style="color:#9CA3AF;margin-left:6px">${u.email}</span>
      </div>
    `).join('');
    document.querySelectorAll('[data-action="share-user"]').forEach(btn => {
      btn.addEventListener('click', function() {
        shareUser(this.dataset.userId);
      });
    });
  }
  results.style.display = 'block';
}

function shareUser(userId) {
  fetch(`/envelopes/${currentEnvelopeId}/share`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({ user_id: userId })
  })
  .then(r => r.json())
  .then(() => {
    document.getElementById('share-user-search').value = '';
    document.getElementById('share-search-results').style.display = 'none';
    loadSharedUsers();
  });
}

function unshareUser(userId) {
  fetch(`/envelopes/${currentEnvelopeId}/unshare`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({ user_id: userId })
  })
  .then(r => r.json())
  .then(() => loadSharedUsers());
}

function attachShareButtons() {
  const searchInput = document.getElementById('share-user-search');
  if (searchInput) {
    const allUsers = JSON.parse(searchInput.dataset.users || '[]');
    searchInput.addEventListener('input', function() {
      searchUsers(this.value, allUsers);
    });
  }

  document.querySelectorAll('[data-action="share-envelope"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openShareModal(this.dataset.envelopeId);
    });
  });

  const closeBtn = document.getElementById('share-modal-close');
  if (closeBtn) closeBtn.addEventListener('click', closeShareModal);

  const doneBtn = document.getElementById('share-modal-done');
  if (doneBtn) doneBtn.addEventListener('click', closeShareModal);
}

// Filter controls apply on change. Wired here rather than inline so the page keeps working
// under the nonce CSP, which blocks inline handlers.
function attachFilterAutosubmit () {
  const form = document.getElementById('envelope-filters')
  // turbo:load re-runs on every navigation; skip if this form was already wired.
  if (!form || form.dataset.autosubmitBound === '1') return
  form.dataset.autosubmitBound = '1'

  let searchTimer = null

  function submitFiltered () {
    // A new filter invalidates the current page number.
    const page = form.querySelector('input[name="page"]')
    if (page) page.remove()
    form.requestSubmit()
  }

  form.querySelectorAll('[data-autosubmit]').forEach(function (input) {
    // Selects / dates / the archived switch: apply as soon as the value changes.
    input.addEventListener('change', submitFiltered)
  })

  // The bar has no submit button, and HTML suppresses implicit submission for a form with
  // several fields and no button — so Enter in the search box has to be handled here.
  // Also debounce on input: waiting for blur (the default `change` on a text field) made
  // the search feel broken when users typed a name and stared at an unfiltered list.
  const search = form.querySelector('input[name="q"]')
  if (search) {
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        clearTimeout(searchTimer)
        submitFiltered()
      }
    })
    search.addEventListener('input', function () {
      clearTimeout(searchTimer)
      searchTimer = setTimeout(submitFiltered, 300)
    })
  }
}

document.addEventListener('DOMContentLoaded', attachShareButtons)
document.addEventListener('turbo:load', attachShareButtons)
document.addEventListener('DOMContentLoaded', attachFilterAutosubmit)
document.addEventListener('turbo:load', attachFilterAutosubmit)
